import {
  CheckCircle,
  ClipboardText,
  CurrencyDollar,
  IdentificationBadge,
  IdentificationCard,
  Note,
  Receipt,
  Tag,
} from '@phosphor-icons/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SubtitleCards } from 'core/components';
import { PricingHelper } from 'pricing/helpers';
import { IProjectDetails } from 'projects/types';

interface IProps {
  project: IProjectDetails;
}

export const ExternalProjectCards = ({ project }: IProps) => {
  const { t } = useTranslation();

  const externalProject = useMemo(() => {
    return project.externalProject;
  }, [project.externalProject]);

  if (!externalProject) {
    return null;
  }

  const cards = [
    {
      label: t('labelExternalProjectNumberShort'),
      icon: <IdentificationBadge weight="fill" />,
      value: externalProject.projectNumber,
    },
    {
      label: t('labelExternalProjectNameShort'),
      icon: <ClipboardText weight="fill" />,
      value: externalProject.projectName,
    },
    {
      label: t('labelExternalProgramNumberShort'),
      icon: <IdentificationCard weight="fill" />,
      value: externalProject.programNumber,
    },
    {
      label: t('labelExternalProgramNameShort'),
      icon: <Note weight="fill" />,
      value: externalProject.programName,
    },
    {
      label: t('labelExternalProjectRecordTypeShort'),
      icon: <Tag weight="fill" />,
      value: externalProject.recordType,
    },
    {
      label: t('labelExternalProjectRequestedFundingAmountShort'),
      icon: <CurrencyDollar weight="fill" />,
      value: PricingHelper.formatPricing({
        amount: externalProject.requestedFundingAmount,
      }),
    },
    {
      label: t('labelExternalProjectApprovedFundingAmountShort'),
      icon: <CheckCircle weight="fill" />,
      value: PricingHelper.formatPricing({
        amount: externalProject.approvedFundingAmount,
      }),
    },
    {
      label: t('labelExternalProjectConsumedFundingAmountShort'),
      icon: <Receipt weight="fill" />,
      value: PricingHelper.formatPricing({
        amount: externalProject.consumedFundingAmount,
      }),
    },
  ];

  return (
    <SubtitleCards
      cards={cards}
      options={{
        contentSx: { justifyContent: 'center' },
        layout: {
          useGrid: true,
        },
      }}
    />
  );
};
